import React, { useState, useRef, useContext, useEffect } from 'react';
import { Plus, Eye, XCircle, ChevronDown } from 'lucide-react';
import StudentLayout from '../../../../layouts/student/StudentLayout';
import '../../../../assets/css/student/dashboard/MyRequests.css';
import AppContext from '../../../../context/AppContext';
import axios from 'axios';

const MyRequests = () => {
  
  const { baseUrl, regExpChecker } = useContext(AppContext);

  const [activeTab, setActiveTab] = useState('Pending');
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [requests, setRequests] = useState([]);

  const [donationType, setDonationType] = useState('');
  const [amount, setAmount] = useState('');
  const [reason, setReason] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('');
  const [accountTitle, setAccountTitle] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [selectedFile, setSelectedFile] = useState('No file chosen');


  // Donation Form Errors
  const [donationTypeError, setDonationTypeError] = useState("");
  const [amountError, setAmountError] = useState("");
  const [reasonError, setReasonError] = useState("");
  const [paymentMethodError, setPaymentMethodError] = useState("");
  const [accountTitleError, setAccountTitleError] = useState("");
  const [accountNumberError, setAccountNumberError] = useState("");

  const fileInputRef = useRef(null);
  const itemsPerPage = 5;

  // ── Raise Ticket Modal State ──
  const [showTicketModal, setShowTicketModal] = useState(false);
  const [ticketForm, setTicketForm] = useState({
    category: 'Uniform',
    subject: '',
    message: '',
    attachment: null
  });

  // View all requests
  const viewAllRequests = () => {
    const formData = new FormData();
    formData.append('student_id', "1");
    axios.post(`${baseUrl}/student/requests/viewAllRequests`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
      .then(res => setRequests(res.data))
      .catch(err => console.log(err));
  };

  // Load selected request data into form
  useEffect(() => {
    if (selectedRequest) {
      setDonationType(selectedRequest.donation_type || '');
      setAmount(selectedRequest.amount || '');
      setReason(selectedRequest.reason || '');
      setPaymentMethod(selectedRequest.payment_method || '');

      const pd = selectedRequest.payment_details || {};
      setAccountTitle(pd.accountTitle || '');
      setAccountNumber(pd.accountNumber || '');

      setSelectedFile('No file chosen');
      if (fileInputRef.current) fileInputRef.current.value = '';
    }
  }, [selectedRequest]);

  // Create request
  const createRequest = () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append('student_id', "1");
    formData.append('donationType', donationType);
    formData.append('amount', amount);
    formData.append('reason', reason);
    formData.append('paymentMethod', paymentMethod);
    formData.append('accountTitle', accountTitle);
    formData.append('accountNumber', accountNumber);

    if (fileInputRef.current?.files) {
      Array.from(fileInputRef.current.files).forEach(file => formData.append('documents', file));
    }

    axios.post(`${baseUrl}/student/requests/createRequest`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
      .then(() => {
        viewAllRequests();
        resetForm();
        setShowModal(false);
      })
      .catch(err => {
        console.log(err);
        alert('Error submitting request');
      })
      .finally(() => setIsLoading(false));
  };

  // Update request
  const updateRequest = (id) => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append('_method', 'PUT');
    formData.append('donationType', donationType);
    formData.append('amount', amount);
    formData.append('reason', reason);
    formData.append('paymentMethod', paymentMethod);
    formData.append('accountTitle', accountTitle);
    formData.append('accountNumber', accountNumber);

    if (fileInputRef.current?.files?.length > 0) {
      Array.from(fileInputRef.current.files).forEach(file => formData.append('documents', file));
    }

    axios.put(`${baseUrl}/student/requests/updateRequest/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
      .then(() => {
        viewAllRequests();
        resetForm();
        setSelectedRequest(null);
        setShowModal(false);
      })
      .catch(err => {
        console.log(err);
        alert('Error updating request');
      })
      .finally(() => setIsLoading(false));
  };

  // Delete request
  const deleteRequest = (id) => {
    if (!window.confirm('Cancel this request?')) return;
    axios.delete(`${baseUrl}/student/requests/deleteRequest/${id}`)
      .then(() => viewAllRequests())
      .catch(err => console.log(err));
  };

  // Reset donation form
  const resetForm = () => {
    setDonationType('');
    setAmount('');
    setReason('');
    setPaymentMethod('');
    setAccountTitle('');
    setAccountNumber('');
    setSelectedFile('No file chosen');
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  // Handle raise ticket submit
  const handleCreateTicket = (e) => {
    e.preventDefault();
    // API call here when backend is ready
    // const fd = new FormData();
    // fd.append('category', ticketForm.category);
    // fd.append('subject', ticketForm.subject);
    // fd.append('message', ticketForm.message);
    // if (ticketForm.attachment) fd.append('attachment', ticketForm.attachment);
    // axios.post(`${baseUrl}/student/tickets/createTicket`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })

    alert('Support ticket submitted successfully!');
    setShowTicketModal(false);
    setTicketForm({ category: 'Uniform', subject: '', message: '', attachment: null });
  };

  useEffect(() => { viewAllRequests(); }, []);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const filteredRequests = requests.filter(req => activeTab === 'All' ? true : req.status === activeTab);
  const currentRequests = filteredRequests.slice(startIndex, startIndex + itemsPerPage);

  return (
    <StudentLayout>
      <div className="srq-container-fluid container-fluid p-4" style={{ backgroundColor: '#191d3a', minHeight: '100vh' }}>
        <div className="row mb-3 align-items-center">
          <div className="col"><h5>My Donation Requests</h5></div>
          <div className="col text-end">
            <button className="btn srq-btn-success" onClick={() => { resetForm(); setSelectedRequest(null); setShowModal(true); }}>
              <Plus size={16} className="me-2" /> New Request
            </button>
          </div>
        </div>

        <ul className="nav nav-tabs srq-nav-tabs">
          {['Pending', 'Approved', 'Completed', 'Rejected'].map(tab => (
            <li className="nav-item" key={tab}>
              <button className={`nav-link ${activeTab === tab ? 'srq-active' : ''}`} onClick={() => setActiveTab(tab)}>{tab}</button>
            </li>
          ))}
        </ul>

        <div className="bg-white rounded shadow-sm p-3 mt-3">
          <table className="table table-hover srq-table">
            <thead>
              <tr><th>#</th><th>Type</th><th>Reason</th><th>Amount</th><th>Status</th><th>Action</th></tr>
            </thead>
            <tbody>
              {currentRequests.length > 0 ? currentRequests.map((req, i) => (
                <tr key={req.id}>
                  <td>{startIndex + i + 1}</td>
                  <td>{req.donation_type}</td>
                  <td>{req.reason}</td>
                  <td>Rs. {req.amount}</td>
                  <td>
                    <span className={`badge ${req.status === 'Pending' ? 'srq-bg-warning' : req.status === 'Approved' ? 'srq-bg-success' : req.status === 'Completed' ? 'srq-bg-info' : 'srq-bg-danger'}`}>
                      {req.status}
                    </span>
                  </td>
                  <td>
                    {/* View / Edit button */}
                    <button className="btn btn-sm srq-btn-primary me-1" onClick={() => { setSelectedRequest(req); setShowModal(true); }}>
                      <Eye size={16} /> View/Edit
                    </button>

                    {/* ── Raise Support Ticket button (next to View) ── */}
                    <button
                      className="btn btn-sm srq-btn-raise-ticket me-1"
                      onClick={() => {
                        setTicketForm({ category: 'Uniform', subject: '', message: '', attachment: null });
                        setShowTicketModal(true);
                      }}
                    >
                      🎫 Raise Ticket
                    </button>

                    {/* Cancel button (Pending only) */}
                    {req.status === 'Pending' && (
                      <button className="btn btn-sm btn-danger" onClick={() => deleteRequest(req.id)}>
                        <XCircle size={16} /> Cancel
                      </button>
                    )}
                  </td>
                </tr>
              )) : <tr><td colSpan="6" className="text-center text-muted">No requests found</td></tr>}
            </tbody>
          </table>
        </div>

        {/* ── Donation Request Modal (View / Edit / New) ── */}
        {showModal && (
          <div className="modal show d-block srq-modal" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content srq-modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{selectedRequest ? 'Edit Request' : 'Apply for Donation'}</h5>
                  <button type="button" className="btn-close" onClick={() => { setShowModal(false); setSelectedRequest(null); resetForm(); }}></button>
                </div>
                <div className="modal-body">

                  <div className="mb-3">
                    <label>Donation Type</label>
                    <select className="form-select"
                     value={donationType} 
                     onChange={e => {
                     setDonationType(e.target.value);
                     setDonationTypeError(regExpChecker("string", e.target.value));
                     }}
                     >
                     <p style={{ color: "red", fontSize: "12px" }}>{donationTypeError}</p>

                      <option value="">Select Type</option>
                      <option value="fee">Fee</option>
                      <option value="books">Books</option>
                      <option value="uniform">Uniform</option>
                    </select>
                  </div>

                  <div className="mb-3">
                    <label>Amount</label>
                    <input type="number" className="form-control" 
                    placeholder="Enter amount"
                    value={amount} 
                    onChange={e => {
                    setAmount(e.target.value)  ;
                    setAmountError(regExpChecker("number", e.target.value));
                    }}
                    />
                     <p style={{ color: "red", fontSize: "12px" }}>{amountError}</p>
                  </div>

                  <div className="mb-3">
                    <label>Reason</label>
                    <textarea className="form-control" 
                    placeholder="Reason..." 
                    value={reason}
                    onChange={e =>{
                    setReason(e.target.value) 
                    setReasonError(regExpChecker("string", e.target.value));
                    }}
                    />
                    <p style={{ color: "red", fontSize: "12px" }}>{reasonError}</p>
                  </div>

                  <div className="mb-3">
                    <label>Receive Donation Via</label>
                    {['bank', 'jazzcash', 'easypaisa'].map(method => (
                      <div className="form-check" key={method}>
                        <input
                          className="form-check-input"
                          type="radio"
                          value={method}
                          checked={paymentMethod === method}
                          onChange={e => setPaymentMethod(e.target.value)}

                        />
                        <label className="form-check-label text-capitalize">{method}</label>
                      </div>
                    ))}
                  </div>

                  {paymentMethod && (
                    <>
                      <div className="mb-3">
                        <label>Account Title</label>
                        <input className="form-control" 
                        value={accountTitle} 
                        onChange={e => {
                        setAccountTitle(e.target.value);
                        setAccountTitleError(regExpChecker("string", e.target.value));
                        }}
                        />
                     <p style={{ color: "red", fontSize: "12px" }}>{accountTitleError}</p>
                      
                      </div>
                      <div className="mb-3">
                        <label>Account Number</label>
                        <input className="form-control" 
                        value={accountNumber} 
                        onChange={e => {
                        setAccountNumber(e.target.value);
                        setAccountNumberError(regExpChecker("number", e.target.value));
                        }}
                         />
                     <p style={{ color: "red", fontSize: "12px" }}>{accountNumberError}</p>

                      </div>
                    </>
                  )}

                  <div className="mb-3">
                    <label>Upload Documents</label>
                    <input
                      type="file"
                      ref={fileInputRef}
                      multiple
                      onChange={e => setSelectedFile(Array.from(e.target.files).map(f => f.name).join(', '))}
                      className="form-control"
                    />
                    <small>Selected: {selectedFile}</small>
                  </div>

                  {!selectedRequest ? (
                    <>
                      <button className="btn srq-btn-success me-2" onClick={createRequest} disabled={isLoading}>
                        {isLoading ? 'Submitting...' : 'Submit Request'}
                      </button>
                      <button className="btn srq-btn-secondary" onClick={() => { setShowModal(false); resetForm(); }}>Cancel</button>
                    </>
                  ) : (
                    <>
                      <button className="btn srq-btn-success me-2" onClick={() => updateRequest(selectedRequest.id)} disabled={isLoading}>
                        {isLoading ? 'Updating...' : 'Update Request'}
                      </button>
                      <button className="btn srq-btn-secondary" onClick={() => { setSelectedRequest(null); setShowModal(false); resetForm(); }}>Cancel</button>
                    </>
                  )}

                </div>
              </div>
            </div>
          </div>
        )}

        {/* ── Raise Support Ticket Modal ── */}
        {showTicketModal && (
          <div className="modal show d-block srq-modal" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1060 }}>
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content srq-modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">🎫 Raise Support Ticket</h5>
                  <button type="button" className="btn-close" onClick={() => setShowTicketModal(false)}></button>
                </div>
                <div className="modal-body">

                  <div className="mb-3">
                    <label>Ticket Category</label>
                    <select
                      className="form-select"
                      value={ticketForm.category}
                      onChange={(e) => setTicketForm({ ...ticketForm, category: e.target.value })}
                    >
                      <option value="Uniform">Uniform Issue</option>
                      <option value="Books">Books Issue</option>
                      <option value="Fee">Fee Issue</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>

                  <div className="mb-3">
                    <label>Subject</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter a short subject"
                      value={ticketForm.subject}
                      onChange={(e) => setTicketForm({ ...ticketForm, subject: e.target.value })}
                    />
                  </div>

                  <div className="mb-3">
                    <label>Message</label>
                    <textarea
                      className="form-control"
                      rows={4}
                      placeholder="Describe your issue in detail..."
                      value={ticketForm.message}
                      onChange={(e) => setTicketForm({ ...ticketForm, message: e.target.value })}
                    />
                  </div>

                  <div className="mb-3">
                    <label>Attach File <small className="text-muted">(Optional)</small></label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={(e) => setTicketForm({ ...ticketForm, attachment: e.target.files[0] || null })}
                    />
                    {ticketForm.attachment && <small>Selected: {ticketForm.attachment.name}</small>}
                  </div>

                  <button className="btn srq-btn-success me-2" onClick={handleCreateTicket}>
                    Submit Ticket
                  </button>
                  <button className="btn srq-btn-secondary" onClick={() => setShowTicketModal(false)}>
                    Cancel
                  </button>

                </div>
              </div>
            </div>
          </div>
        )}

      </div>
    </StudentLayout>
  );
};

export default MyRequests;